import { capture } from "./analytics"

const PODSQUEEZE_REFERRAL_SESSION_KEY = "photosharpener_podsqueeze_referral_logged"

function isPodsqueezeReferral(search: string): boolean {
  const params = new URLSearchParams(search)
  return (
    params.get("podsqueeze") === "true" ||
    params.get("utm_source") === "podsqueeze" ||
    params.get("utm") === "podsqueeze" ||
    params.get("referer") === "podsqueeze"
  )
}

/** Log a single landing_page_podsqueeze_referral per browser session. */
export function trackPodsqueezeReferralIfPresent(): void {
  if (typeof window === "undefined") return
  if (sessionStorage.getItem(PODSQUEEZE_REFERRAL_SESSION_KEY) === "true") return
  if (!isPodsqueezeReferral(window.location.search)) return

  const params = new URLSearchParams(window.location.search)

  sessionStorage.setItem(PODSQUEEZE_REFERRAL_SESSION_KEY, "true")
  capture("landing_page_podsqueeze_referral", {
    landing_path: window.location.pathname,
    utm_source: params.get("utm_source") || params.get("utm"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    referer: params.get("referer"),
    podsqueeze: params.get("podsqueeze") === "true",
  })
}
